import {connect} from 'react-redux'
import Header from '../Header'
import PermissionForm from './PermissionForm'
import * as actPermission from 'actions/employees/permission'
import styles from './Permission.css'
import {isDirty} from 'redux-form'
import ConfirmActionModal from 'components/ConfirmActionModal'
import {askConfirmAction} from 'actions/confirm-action'
import {browserHistory} from 'react-router'

class Permission extends React.Component {
  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    if (!expired) {
      this.props.dispatch(actPermission.pageRequest())

      browserHistory.listenBefore((location) => {
        if (this.props.data.isDirtyForm && this.props.data.confirmAction.nextAction === null) {
          // negate the change location, instead use sagas to handle the change location
          this.props.dispatch(askConfirmAction(actPermission.changePage(location.pathname)))
          return false
        }
      })
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  render () {
    return <div className={styles.wrapper}>
      <div className='col-sm-6 no-padding'>
        <Header title='Permission' />
        <PermissionForm onSubmit={this._onSubmit} />
      </div>
      <ConfirmActionModal />
    </div>
  }

  _onSubmit = (values) => {
    let data = {...this.props.data.employee.permission.setting}
    data.auth_code = values.authCode
    data.allow_staff_refund = values.allowStaffRefund
    data.staff_delete_bill = values.staffDeleteBill
    data.staff_resend_receipt = values.staffResendReceipt
    this.props.dispatch(actPermission.submitForm({settings: data}, {}))
  }
}

Permission.propTypes = {
  dispatch: React.PropTypes.func,
  history: React.PropTypes.object
}

function mapStateToProps (state) {
  return {
    data: {
      confirmAction: state.confirmAction,
      isDirtyForm: isDirty('permission')(state),
      employee: {
        permission: state.employee.permission
      },
      subscriptionExpired: state.subscriptionExpired
    }
  }
}

export default connect(mapStateToProps)(Permission)



// WEBPACK FOOTER //
// ./app/pages/Employees/Permission/Permission.js